import { primaryCurrency } from '../primaryCurrency/primaryCurrency'
import { number } from 'svelte-i18n'
import { derived } from 'svelte/store'

export const price = derived([number, primaryCurrency], ([number, $primaryCurrency]) => {
	return (value: number, currencyCode?: string) =>
		number(value, {
			style: 'currency',
			currency: currencyCode || $primaryCurrency,
		})
})
